import { LOCAL_STORAGE_REAUTH_EMAIL } from '../../../../constants/storage'
import { getEmailAvailableAccounts } from '../../../../utils/email'
import { getStorageItem } from '../../../../utils/storage'
import {
  EMAIL_ACCOUNT_TYPE_CORPORATE,
  EMAIL_ACCOUNT_TYPE_PRIVATE,
  EMAIL_ACCOUNT_TYPE_SHARED,
  EMAIL_NEED_RECONNECT,
} from '../../Email.constants'

function isReauthEarlierThanToday(value) {
  return Date.now() - value > 24 * 3600 * 1000
}

export function getAccountsList(accounts) {
  return [
    ...getEmailAvailableAccounts(accounts[EMAIL_ACCOUNT_TYPE_PRIVATE]),
    ...getEmailAvailableAccounts(accounts[EMAIL_ACCOUNT_TYPE_CORPORATE]),
    ...getEmailAvailableAccounts(accounts[EMAIL_ACCOUNT_TYPE_SHARED]),
  ].filter(i => i[EMAIL_NEED_RECONNECT] && i?.permissions.can_reconnect)
}

export function getReauthValues() {
  const hideReauthTs = getStorageItem(LOCAL_STORAGE_REAUTH_EMAIL)

  const showReauth = !hideReauthTs || isReauthEarlierThanToday(hideReauthTs)

  return showReauth
}
